import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import dayjs from 'dayjs';
import { AmericanCountryList } from '../constants/quote';
/**
 * Converts the client start and end dates to an actual end date based on specific rules.
 *
 * @param clientStart The client start date in string format.
 * @param clientEnd The client end date in string format.
 * @returns The actual end date as a Date object, or null if the input is invalid.
 */

export function convertActualDate(clientStart, clientEnd) {
  var start = new Date(clientStart);
  var end = new Date(clientEnd);
  var diffMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  var nextCycleEnd = new Date(end);

  if (diffMonths < 3) {
    nextCycleEnd.setMonth(start.getMonth() + 3);
  } else {
    if (end.getDate() < start.getDate()) {
      nextCycleEnd.setMonth(nextCycleEnd.getMonth() + 1);
    }

    nextCycleEnd.setDate(start.getDate());
  }

  return nextCycleEnd;
}
export function calculateDatePeriod(startDate, endDate) {
  if (startDate > endDate) throw new Error('Start date must be before the end date.');
  var timeDiff = endDate.getTime() - startDate.getTime();
  var days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  var weeks = Math.ceil(days / 7);
  var months = Math.ceil(days / 30.44);
  return {
    days: days,
    weeks: weeks,
    months: months
  };
}
export var JoveDateFormatTypeEnum;

(function (JoveDateFormatTypeEnum) {
  JoveDateFormatTypeEnum["DAYJS_UPPERCASE"] = "DAYJS_UPPERCASE";
  JoveDateFormatTypeEnum["REACT_LOWERCASE_DATE_PICKER"] = "REACT_LOWERCASE_DATE_PICKER";
})(JoveDateFormatTypeEnum || (JoveDateFormatTypeEnum = {}));

export function getDateFormat(country, formatType, config) {
  var _formatMap;

  var isAmericanCountry = AmericanCountryList.includes(country);
  var delimiter = (config === null || config === void 0 ? void 0 : config.delimiter) || '/';
  var formatMap = (_formatMap = {}, _defineProperty(_formatMap, JoveDateFormatTypeEnum.DAYJS_UPPERCASE, {
    american: "MM".concat(delimiter, "DD").concat(delimiter, "YYYY"),
    other: "DD".concat(delimiter, "MM").concat(delimiter, "YYYY")
  }), _defineProperty(_formatMap, JoveDateFormatTypeEnum.REACT_LOWERCASE_DATE_PICKER, {
    american: "MM".concat(delimiter, "dd").concat(delimiter, "yyyy"),
    other: "dd".concat(delimiter, "MM").concat(delimiter, "yyyy")
  }), _formatMap);
  return isAmericanCountry ? formatMap[formatType].american : formatMap[formatType].other;
}
export var getDaysDiffFromToday = function getDaysDiffFromToday(dateString) {
  if (!dateString) {
    return null;
  }

  var targetDate = dayjs(dateString);

  if (!targetDate.isValid()) {
    return null;
  }

  var rawDiff = targetDate.diff(dayjs(), 'day', true);
  if (rawDiff < 0) return 0;
  return Math.ceil(rawDiff);
};